/** Тексты окна: Проигрыш: одна главная кнопка (реванш, таймер или бой), совет и предложения строками. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.defeat.title": "Base fell",
  "win.defeat.back": "Back to wave {n}",
  "win.defeat.stay": "Wave {n} again",
  "win.defeat.summary": "Wave {wave} · back to {n}",
  "win.defeat.coinsKept": "{coins} kept",
  "win.defeat.adviceLevel": "Upgrade {hero} to Lv\u00a0{level}",
  "win.defeat.adviceStar": "Raise {hero} to rank {star}",
  "win.defeat.adviceGain": "+{pct}% damage",
  "win.defeat.wait": "Next fight in {s} s",
  "win.defeat.skip": "Skip the wait",
  "win.defeat.vipLine": "VIP: no wait, x2, auto skills",
  "win.defeat.starterLine": "Starter pack: {coins} + {days} days of VIP",
  "win.revive.title": "Rematch wave {n}",
  "win.revive.effect": "The wave starts over with a full base, plus {n} boosts of your choice.",
  "win.revive.boosts": "Your boosts stay:",
  "win.revive.free": "free",
  "win.revive.attempt": "{n} of {max}",
  "win.defeat.fight": "Fight",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.defeat.title": "Штаб пал",
  "win.defeat.back": "Назад на волну {n}",
  "win.defeat.stay": "Снова волна {n}",
  "win.defeat.summary": "Волна {wave} · назад на {n}",
  "win.defeat.coinsKept": "{coins} остались",
  "win.defeat.adviceLevel": "Прокачай {hero} до ур.\u00a0{level}",
  "win.defeat.adviceStar": "Подними {hero} до ранга {star}",
  "win.defeat.adviceGain": "+{pct}% урона",
  "win.defeat.wait": "Следующий бой через {s} с",
  "win.defeat.skip": "Пропустить",
  "win.defeat.vipLine": "VIP: без ожидания, x2, автонавыки",
  "win.defeat.starterLine": "Стартовый пакет: {coins} + {days} дня VIP",
  "win.revive.title": "Реванш: волна {n}",
  "win.revive.effect": "Волна заново: штаб полный и +{n} усиления на выбор.",
  "win.revive.boosts": "Твои усиления останутся:",
  "win.revive.free": "бесплатно",
  "win.revive.attempt": "{n} из {max}",
  "win.defeat.fight": "В бой",
};

const uk: Record<Key, string> = {
  "win.defeat.title": "Штаб упав",
  "win.defeat.back": "Назад на хвилю {n}",
  "win.defeat.stay": "Знову хвиля {n}",
  "win.defeat.summary": "Хвиля {wave} · назад на {n}",
  "win.defeat.coinsKept": "{coins} залишились",
  "win.defeat.adviceLevel": "Прокачай {hero} до рів.\u00a0{level}",
  "win.defeat.adviceStar": "Підніми {hero} до рангу {star}",
  "win.defeat.adviceGain": "+{pct}% шкоди",
  "win.defeat.wait": "Наступний бій через {s} с",
  "win.defeat.skip": "Пропустити",
  "win.defeat.vipLine": "VIP: без очікування, x2, автонавички",
  "win.defeat.starterLine": "Стартовий пакет: {coins} + {days} дні VIP",
  "win.revive.title": "Реванш: хвиля {n}",
  "win.revive.effect": "Хвиля заново: штаб повний і +{n} посилення на вибір.",
  "win.revive.boosts": "Твої посилення залишаться:",
  "win.revive.free": "безкоштовно",
  "win.revive.attempt": "{n} з {max}",
  "win.defeat.fight": "У бій",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
